import { render } from "./folder.vue?vue&type=template&id=b8f4eca4&ts=true"
import script from "./folder.vue?vue&type=script&lang=ts"
export * from "./folder.vue?vue&type=script&lang=ts"

import "./folder.vue?vue&type=style&index=0&id=b8f4eca4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__